module.exports = __webpack_public_path__ + "public/img/code_2.50377d44.jpg";